module.exports = __webpack_public_path__ + "static/media/Nilou.d978cf1c.png";